@if (order | orderValue: type : quoteToUse; as orderValue) {
  <div class="zero-text" [class.course-green]="orderValue > 0" [class.course-red]="orderValue < 0">{{ orderValue | currency }}</div>
} @else {
  <div>&mdash;</div>
}
